import React from 'react'
import { LogoLargeContainer } from '../../pages/auth/styledComponents'

const LogoLarge = function LogoLarge ({ color, icon, func }) {
  return (
    <LogoLargeContainer
      onClick={func}
      dangerouslySetInnerHTML={{ __html: icon }}
      style={{
        fill: color,
      }}
    />
  )
}

export default LogoLarge
